import { Avatar, AvatarProps, Text } from "rizzui";
import cn from "../utils/class-names";

interface AvatarLoaderCardProps {
    src?: string;
    name: string;
    className?: string;
    avatarClassName?: string;
    nameClassName?: string;
    avatarProps?: AvatarProps;
    description?: React.ReactNode;
}

export default function AvatarLoaderCard({
    src,
    name,
    className,
    avatarClassName,
    description,
    avatarProps,
    nameClassName,
}: AvatarLoaderCardProps) {
    return (
        <figure
            className={cn("flex items-center gap-3", className, src && "pr-6")}
        >
            {src && (
                <Avatar
                    name={name}
                    src={import.meta.env.VITE_APP_ImagePath + src}
                    className={cn(avatarClassName)}
                    {...avatarProps}
                />
            )}

            <figcaption className="grid gap-0.5 capitalize">
                <Text
                    className={cn(
                        "font-lexend text-sm font-medium text-gray-900 dark:text-gray-700",
                        nameClassName,
                    )}
                >
                    {name}
                </Text>

                {description && (
                    <Text className="text-[13px] text-gray-500 capitalize">
                        {description}
                    </Text>
                )}
            </figcaption>
        </figure>
    );
}
